export default __webpack_public_path__ + "static/media/lad.5b415927.png";